import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'
import type { Vault } from '@/types/vault'
import { getProtocolDisplayName } from '@/utils/protocol'
import { Link } from 'react-router'

interface Props {
  protocol: Vault['protocol']
  className?: string
}

export const GenericNonInstantRedemptionNote = ({ protocol, className }: Props) => {
  const { protocolUrl } = protocol
  const protocolDisplayName = getProtocolDisplayName(protocol)

  return (
    <Note color="orange" className={className}>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Redemption note</h6>
      </div>
      <p className="block text-xs">
        Redemptions from this vault may not be instant. Withdrawal process can take some time depending on the protocol
        rules. To learn more, visit the{' '}
        {protocolUrl ? (
          <Link
            to={protocolUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-block hocus-within:text-accent underline transition-colors"
          >
            <span className="inline-block underline">{protocolDisplayName}</span> app
          </Link>
        ) : (
          <span>
            <span className="inline-block">{protocolDisplayName}</span> protocol website
          </span>
        )}
        .
      </p>
    </Note>
  )
}
